import { createSlice } from '@reduxjs/toolkit';

import InsuranceProductType from 'Feature/Common/Common/Types/Enums/InsuranceProductType';

import IElhaghiyehHaState from './model';

const initialState: IElhaghiyehHaState = {
  selectedInsuranceProductType: InsuranceProductType.BIMEH_SHAKHS_SALES,
};

export const elhaghiyehHaSlice = createSlice({
  name: 'atashsoozi/elhaghiyehHa',
  initialState,
  reducers: {
    setSelectedInsuranceProductType: (state, action) => {
      state.selectedInsuranceProductType = action.payload;
    },
  },
});

export const { setSelectedInsuranceProductType } = elhaghiyehHaSlice.actions;

export default elhaghiyehHaSlice.reducer;
